import { Alert, Grid, Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import CustomerInvoiceOnlinePayment from "../../../../components/payment-gateway/CustomerInvoiceOnlinePayment";
import PaymentSummaryWidget from "../../../../components/payment-gateway/PaymentSummaryWidget";
import PanelBalanceCard from "../../../../components/payment-gateway/PanelBalanceCard";

const CustomerInvoicePaymentPage = () => {
  const { invoiceId } = useParams();
  const id = Number(invoiceId);

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={8} lg={6} sx={{ mx: "auto" }}>
        {!id || Number.isNaN(id) ? (
          <Alert severity="error">شناسه فاکتور معتبر نیست.</Alert>
        ) : (
          <Stack spacing={2}>
            <PanelBalanceCard compact />
            <PaymentSummaryWidget compact highlightInvoiceId={id} />
            <CustomerInvoiceOnlinePayment invoiceId={id} />
          </Stack>
        )}
      </Grid>
    </Grid>
  );
};

export default CustomerInvoicePaymentPage;
